import { Area } from "./area.model";
import {City} from "./city.model";
export interface IDistrict {
  id?: number;
  name?: string;
  area_id?: Area;
  city?: City;
}

export class District implements IDistrict {
  constructor(
    public id?: number,
    public name?: string,
    public area_id?: Area,
    public city?: City
  ) {
    this.id = id;
    this.name = name;
    this.area_id = area_id;
    this.city = city;
  }
}
